// test1038
(1038 && 0);
